import { useState, useEffect } from 'react'
import DialogueTurn from './DialogueTurn'

export default function EpisodeCard({ episode, forceExpanded }) {
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    setExpanded(forceExpanded)
  }, [forceExpanded])

  const turnCount = episode.dialogue?.length || 0

  return (
    <div className="card bg-base-100 shadow overflow-hidden">
      {/* Episode header - clickable */}
      <div
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-base-200 transition-colors"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex-1">
          <div className="flex items-center gap-3">
            <span className="badge badge-primary badge-lg font-mono">
              {episode.episode_number}
            </span>
            <div>
              <h3 className="font-semibold">{episode.title}</h3>
              <div className="flex gap-3 text-xs text-base-content/60 mt-0.5">
                <span>{episode.phase}</span>
                {episode.setting && <span>{episode.setting}</span>}
                {episode.episode_date && <span>{episode.episode_date}</span>}
                <span>{turnCount} turns</span>
                {episode.nurse_present && (
                  <span className="text-teal-600 font-medium">+ Nurse</span>
                )}
              </div>
            </div>
          </div>
        </div>
        <span className="text-base-content/40 text-lg">
          {expanded ? '▼' : '▶'}
        </span>
      </div>

      {/* Expanded content */}
      {expanded && (
        <div className="border-t border-base-200">
          {/* Dialogue */}
          <div className="p-4 space-y-2">
            {episode.dialogue?.map((turn, idx) => (
              <DialogueTurn key={idx} turn={turn} />
            ))}
          </div>

          {/* Clinical notes */}
          {episode.clinical_notes && (
            <div className="border-t border-base-200 p-4">
              <h4 className="font-semibold text-sm text-blue-700 mb-2">Clinical Notes</h4>
              <div className="bg-blue-50 rounded-lg p-3 text-sm whitespace-pre-wrap">
                {episode.clinical_notes}
              </div>
            </div>
          )}

          {/* Nursing notes */}
          {episode.nursing_notes && (
            <div className="border-t border-base-200 p-4">
              <h4 className="font-semibold text-sm text-teal-700 mb-2">Nursing Notes</h4>
              <div className="bg-teal-50 rounded-lg p-3 text-sm whitespace-pre-wrap">
                {episode.nursing_notes}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
